import moment from 'moment/moment';

import { YEAR_DASH_MONTH_DASH_DAY } from '../../../../../../constants/dateFormat';

export function preparePersonnelInfoState(personnelInfo) {
  const momentStartDate = personnelInfo.startDate ? moment(personnelInfo.startDate, YEAR_DASH_MONTH_DASH_DAY) : null;
  return { ...personnelInfo, startDate: momentStartDate };
}

export function preparePersonnelInfoRequest(personnelInfo) {
  const startDateString = personnelInfo.startDate ? personnelInfo.startDate.format(YEAR_DASH_MONTH_DASH_DAY) : null;
  return { ...personnelInfo, startDate: startDateString };
}
